$(document).ready(function(){
 $("img[src='https://cdn.shopify.com/s/files/1/0089/6309/6636/files/31f2b3004835b09d9d420352c62e9087abe37a01c6dec61c02c95d6ef0029e7d.webp?v=1697750697']").attr("alt", "Person holding whiskey glass");
// Add aria-label to close filters button
$("a.filters__close").attr("aria-label", "Close filters");

// Add aria-label to filter shade (if interactive, like a backdrop click-to-close)
$(".filter-shade").attr("aria-label", "Filter overlay");

// Add aria-label to layout switch (assuming it toggles layout views)
$("a.layout-switch").attr("aria-label", "Switch layout view");
$("div.announcement__text a[href='']").attr("aria-label","Annoucement");
  setTimeout(function(){
$("span.product-label.product-label--new-in>span").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });

 
$("span.product-label.product-label--sale>span").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });

$("img[src*='thumbnail.0000000_1024x.jpg']").attr("alt", "thumbnail");
$("img[src*='thumbnail.0000000000_1024x.jpg']").attr("alt", "thumbnail");

    
  },1000)
$("img[src='//www.thewinesavant.com/cdn/shop/files/The_Wine_Savant_Logo_510x.png?v=1690401496']").attr("alt", "The Wine Savant logo");
let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;


   
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 $("img.add-to-cart__success").attr("alt","add to cart success");     
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}



});
